import React, { useState, useEffect } from 'react';
import { Form } from 'antd';
import { useHistory } from 'react-router-dom';
import styles from './styles';
import { Fonts } from '../../../shared/theme';
import CommonStyle from '../../../shared/theme/common-style';
import { Images } from '../../../shared/theme';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../shared/components/rbh-text/styles';
import { useDispatch } from 'react-redux';
import { CommonValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { RBHBox, RBHText, RBHTextInput, RBHTextPasswordInput, RBHButton, RBHImage } from '../../../shared/components';
import { authSagas } from '../../auth-saga';
import { AUTH_REQUEST_ID_LIST, COGNITO_LOCAL_STORAGE_KEY } from '../../auth-constant';
import { CheckCircleOutlined } from '@ant-design/icons';
import { AuthHelper } from '../../auth-helper';
import { getLocalStorage, clearLocalStorage } from '../../../shared/helpers/utility';
import './styles.css';
import images from '../../../shared/theme/images';

export const SetNewScreen: React.FC<Props> = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [formInvalid, setFormInvalid] = useState(true);
  const userId = getLocalStorage(COGNITO_LOCAL_STORAGE_KEY.MERCHANT_USER_ID);
  const [isSuccess, setIsSuccess] = useState(false);
  const dispatch = useDispatch();
  const goToLogin = () => {
    history.push('/signin');
  };

  useEffect(() => {
    if (!userId) {
      goToLogin();
    }
  }, []);

  const goLogin = () => {
    history.push('/signin');
  };

  const submitSuccess = () => {
    setIsSuccess(true);
    clearLocalStorage(COGNITO_LOCAL_STORAGE_KEY.MERCHANT_USER_ID);
  };

  const onFinishPassword = (values: any) => {
    dispatch(httpCreators.request({
      service: AuthHelper.forgotPasswordSubmit,
      serviceParams: {
        merchantUserId: String(userId),
        ConfirmationCode: String(values.passwordAWS),
        Password: String(values.confirmPassword)
      },
      id: AUTH_REQUEST_ID_LIST.FORGOT_PASSWORD_COMFIRM,
      sagaHandler: authSagas.forgotPasswordConfirmHandle,
      callbackParams: submitSuccess
    }));
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }
    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const successBox = () => {
    return (
      <RBHBox style={styles.successBox}>
        <RBHBox style={styles.contentModal}>
          <RBHBox style={styles.successIconBox}>
            <CheckCircleOutlined id={'icon_success'} translate={null} style={styles.successIconImage} />
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHText id={'success_title'} style={Fonts.style.textHeaderKanitMediumFakeBlack}>
              <FormattedMessage id={'main.setnewpassword.successbox.title'} />
            </RBHText>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTop}>
            <RBHText id={'success_description'} style={Fonts.style.textDescription}>
              <FormattedMessage id={'main.setnewpassword.successbox.description'} />
            </RBHText>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHButton id={'success_button'} style={styles.buttonBox} onClick={goToLogin}>
              <FormattedMessage id={'main.setnewpassword.successbox.button'} />
            </RBHButton>
          </RBHBox>
        </RBHBox>
      </RBHBox>
    );
  };

  const setNewPasswordBox = () => {
    return (
      <RBHBox style={styles.setNewPasswordBox}>
        <RBHBox style={{ padding: 40 }}>
          <RBHBox style={styles.iconBox}>
            <RBHImage style={styles.iconImage} src={Images.logoIcon} />
          </RBHBox>

          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHText id={'setnewpassword_title'} style={Fonts.style.headerFakeBlack}>
              <RBHImage style={styles.iconBack} src={images.back}
                onClick={() => history.push('/forgotpassword')} />
              <FormattedMessage id={'main.setnewpassword.title'} />
            </RBHText>
            <RBHText id={'setnewpassword_description'} style={Fonts.style.textcontentKanitRegular}>
              <FormattedMessage id={'main.setnewpassword.description'} />
            </RBHText>
          </RBHBox>

          <RBHBox style={CommonStyle.paddingTopLarge}>
            <Form size='small' form={form} style={styleText.formText}
              onFieldsChange={checkFormInvalid} onFinish={onFinishPassword}>

              <Form.Item colon={false} name='passwordAWS' validateTrigger={['onChange', 'onBlur']}
                label={<FormattedMessage id={'main.setnewpassword.form.verifycode.title'} />}>
                <RBHTextInput
                  id='passwordAWS'
                  autoComplete='off'
                  placeholder={'main.setnewpassword.form.verifycode.placeholder'}
                  onBlur={() => trimFieldValue('passwordAWS')} />
              </Form.Item>

              <Form.Item colon={false} name='newPassword' validateTrigger={['onChange', 'onBlur']}
                label={<FormattedMessage id={'main.setnewpassword.form.newpassword.title'} />}
                rules={[
                  {
                    pattern: /^.{8,}$/,
                    message: <FormattedMessage id={'main.setnewpassword.form.error.formatpassword'} />
                  },
                  ({ getFieldValue }) => ({
                    validator(_, formValue) {
                      if (formValue === getFieldValue('confirmPassword') ||
                        formValue !== getFieldValue('confirmPassword')) {
                        form.validateFields(['confirmPassword']);
                      }
                      return Promise.resolve();
                    }
                  })
                ]}>
                <RBHTextPasswordInput
                  id='newPassword'
                  placeholder={'main.setnewpassword.form.newpassword.placeholder'}
                  onBlur={() => trimFieldValue('newPassword')}
                  autoComplete='new-password'
                  maxLength={CommonValidator.Password.maxLength} />
              </Form.Item>

              <Form.Item colon={false} name='confirmPassword' validateTrigger={['onChange', 'onBlur']}
                label={<FormattedMessage id={'main.setnewpassword.form.confirmpassword.title'} />}
                rules={[
                  {
                    pattern: /^.{8,}$/,
                    message: <FormattedMessage id={'main.setnewpassword.form.error.formatpassword'} />
                  },
                  ({ getFieldValue }) => ({
                    validator(_, formValue) {
                      if (getFieldValue('newPassword') === formValue) {
                        return Promise.resolve();
                      }
                      if (formValue !== getFieldValue('newPassword')) {
                        if (!CommonValidator.Password.regexPattern.test(formValue)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(<FormattedMessage id={'main.setnewpassword.form.error.samepassword'} />);
                        }
                      }
                      return Promise.resolve();
                    }
                  })
                ]}>
                <RBHTextPasswordInput
                  id='confirmPassword'
                  placeholder={'main.setnewpassword.form.confirmpassword.placeholder'}
                  autoComplete='off'
                  onBlur={() => trimFieldValue('confirmPassword')}
                  maxLength={CommonValidator.Password.maxLength}
                />
              </Form.Item>

              <RBHButton id={'setnewpassword_button'} style={styles.buttonBox}
                disabled={formInvalid} type='primary' htmlType='submit'>
                <FormattedMessage id={'main.setnewpassword.form.confirmpassword.button'} />
              </RBHButton>
            </Form>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHText id={'linkable_to_login'} style={styles.textInner} onClick={goLogin}>
              <FormattedMessage id={'main.forgotpassword.linkable'} />
            </RBHText>
          </RBHBox>
        </RBHBox>
      </RBHBox>
    );
  };

  return (
    <RBHBox style={styles.setNew_layout}>
      <RBHBox style={styles.setNewPassword_content}>
        {isSuccess ? successBox() : setNewPasswordBox()}
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
